import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Shield Airplane"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
  selector: 'app-icon-shield-airplane',
  templateUrl: './icon-shield-airplane.html',
  styleUrl: './icon-shield-airplane.scss',
  standalone: false,
})
export class IconShieldAirplaneComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
